import {createApp} from 'vue';
import pinia from '@/plugins/pinia';
import router from '@/plugins/router';
import apiHook from "@/plugins/apiHook";
import vuetify from '@/plugins/vuetify';
import axios from '@/plugins/axios';
import network from '@/plugins/network';
import datepicker from '@/plugins/datepicker';

import App from './App.vue';

const app = createApp(App);

app.use(router);
app.use(pinia);
app.use(apiHook);
app.use(vuetify);
app.use(axios);
app.use(network);
app.use(datepicker);

app.mount('#app');
